var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureSql(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_147)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.526 114.576C161.015 92.7647 147.36 75.5443 130.902 76.0092C117.788 75.7961 106.032 86.6436 101.592 103.012C87.6752 105.511 77.2337 121.123 77 139.738C77.4235 160.852 90.6544 177.511 106.572 176.988H157.612C170.741 176.562 181.372 162.751 182 145.375C181.766 129.84 173.106 116.823 161.526 114.576Z",
    fill: "url(#paint0_linear_6_147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.888 148.064V121.409H146.637V153.796H161V148.064H151.888ZM110.173 134.972C109.091 134.384 108.082 133.559 107.19 132.538C106.956 132.205 106.765 131.812 106.648 131.38C106.531 130.949 106.473 130.497 106.488 130.026C106.458 129.084 106.78 128.201 107.365 127.671C108.082 127.003 108.945 126.67 109.822 126.729C111.899 126.611 113.962 127.396 115.658 129.005V122.273C113.786 121.331 111.812 120.919 109.822 121.017C107.526 120.86 105.274 121.802 103.46 123.686C101.851 125.355 100.944 127.946 101.003 130.654C101.003 134.658 102.875 137.799 106.839 140.134C108.126 140.861 109.34 141.822 110.466 142.961C111.022 143.589 111.344 144.492 111.344 145.473C111.344 146.435 110.992 147.338 110.407 147.907C109.618 148.535 108.696 148.83 107.775 148.771C105.42 148.751 103.167 147.573 101.412 145.473V152.755C103.343 154.09 105.493 154.738 107.658 154.64C110.1 154.836 112.528 153.933 114.547 152.049C115.995 150.204 116.711 147.573 116.477 144.924C116.507 142.922 115.98 140.959 115.015 139.428C113.654 137.504 112.016 135.973 110.173 134.972ZM140.786 147.436C143.375 141.862 143.375 134.815 140.786 129.241C139.88 126.787 138.446 124.746 136.691 123.353C134.907 121.998 132.903 121.311 130.855 121.331C128.646 121.272 126.467 121.998 124.551 123.451C122.752 124.805 121.26 126.807 120.28 129.241C119.242 132.009 118.715 135.09 118.759 138.191C118.774 140.92 119.256 143.589 120.163 146.023C121.055 148.437 122.46 150.459 124.2 151.813C125.97 153.266 127.974 154.07 130.036 154.168L135.067 162H142.132L134.95 153.383C137.364 152.422 139.441 150.302 140.786 147.436ZM134.95 145.473C133.868 147.279 132.23 148.28 130.504 148.221C128.764 148.3 127.111 147.259 126.058 145.395C124.829 143.138 124.229 140.35 124.361 137.563C124.229 134.756 124.829 131.989 126.058 129.732C127.169 127.887 128.851 126.827 130.621 126.827C132.362 126.729 134.014 127.808 135.009 129.732C136.164 132.048 136.72 134.796 136.589 137.563C136.793 140.37 136.208 143.196 134.95 145.473Z",
    fill: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_147",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_147",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_147",
    x1: 134.831,
    y1: 182.681,
    x2: 110.834,
    y2: 80.1187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2974BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#679CD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B6E2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureSql);
export default __webpack_public_path__ + "static/media/azure-sql.bc58c6c1ca56ef066e330e053085fd58.svg";
export { ForwardRef as ReactComponent };